import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-e3cdf4ca")

_pushScopeId("data-v-e3cdf4ca")
const _hoisted_1 = { class: "muted-cell" }
const _hoisted_2 = { class: "actions-cell" }
const _hoisted_3 = { class: "set-part-time-job" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" ⌚️ ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_user_in_table = _resolveComponent("user-in-table")

  return (_openBlock(), _createBlock("tr", {
    class: { 'is-deactivated': !_ctx.user.isActive }
  }, [
    _createVNode(_component_user_in_table, {
      user: _ctx.user,
      class: "muted-cell"
    }, null, 8, ["user"]),
    _createVNode("td", _hoisted_1, _toDisplayString(_ctx.user.role), 1),
    _createVNode("td", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("label", {
          class: "checkbox",
          title: _ctx.partTimeLabelTitle
        }, [
          _withDirectives(_createVNode("input", {
            type: "checkbox",
            onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.setPartTimeJob && _ctx.setPartTimeJob(...args))),
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.partTimeInfo = $event))
          }, null, 544), [
            [_vModelCheckbox, _ctx.partTimeInfo]
          ]),
          _createVNode("span", {
            class: ["part-time-info", { 'part-time-mark': _ctx.partTimeInfo }]
          }, "part-time job", 2),
          _hoisted_4
        ], 8, ["title"])
      ]),
      (_ctx.user.role === 'user')
        ? (_openBlock(), _createBlock("button", {
            key: 0,
            class: ["button is-small is-info is-outlined", { 'is-loading': _ctx.isLoading }],
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.grantAdmin && _ctx.grantAdmin(...args)))
          }, " grant admin ", 2))
        : (_openBlock(), _createBlock("button", {
            key: 1,
            class: ["button is-small is-outlined is-danger", { 'is-loading': _ctx.isLoading }],
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.revokeAdmin && _ctx.revokeAdmin(...args))),
            disabled: _ctx.currentUser.id === _ctx.user.id
          }, " revoke admin ", 10, ["disabled"])),
      _createVNode("button", {
        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.deleteUser && _ctx.deleteUser(...args))),
        class: [{ 'is-loading': _ctx.isLoading }, "button is-small is-outlined is-danger mt-2"]
      }, " Delete ", 2),
      _createVNode("button", {
        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.toggleActive && _ctx.toggleActive(...args))),
        class: [{ 'is-loading': _ctx.isLoading }, "button is-small is-outlined mt-2"],
        disabled: _ctx.currentUser.id === _ctx.user.id
      }, _toDisplayString(_ctx.user.isActive ? 'Deactivate' : 'Activate'), 11, ["disabled"]),
      (_ctx.isServiceUser)
        ? _withDirectives((_openBlock(), _createBlock("input", {
            key: 2,
            type: "text",
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.token = $event)),
            class: "input is-small mt-2",
            placeholder: "token"
          }, null, 512)), [
            [_vModelText, _ctx.token]
          ])
        : _createCommentVNode("", true),
      (_ctx.isServiceUser)
        ? (_openBlock(), _createBlock("button", {
            key: 3,
            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.updateToken && _ctx.updateToken(...args))),
            class: "button is-small is-outlined is-info mt-2"
          }, " Update token "))
        : _createCommentVNode("", true)
    ])
  ], 2))
})